/**
 * Utility functions for handling subdomain routing
 */

export const getSubdomain = (): string | null => {
  const hostname = window.location.hostname;
  
  // Handle localhost development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return null;
  }
  
  // Extract subdomain from hostname
  const parts = hostname.split('.');
  
  // If we have at least 3 parts (e.g., app.catlyo.com), first part is subdomain
  if (parts.length >= 3) {
    return parts[0];
  }
  
  return null;
};

export const isAppSubdomain = (): boolean => {
  const subdomain = getSubdomain();
  return subdomain === 'app';
};

export const getAppUrl = (): string => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:${window.location.port}`;
  }
  
  // For production, construct app subdomain URL
  const parts = hostname.split('.');
  if (parts.length >= 2) {
    const domain = parts.slice(-2).join('.');
    return `${protocol}//app.${domain}`;
  }
  
  return `${protocol}//${hostname}`;
};

export const getMarketingUrl = (): string => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:${window.location.port}`;
  }
  
  // For production, construct root domain URL
  const parts = hostname.split('.');
  if (parts.length >= 2) {
    const domain = parts.slice(-2).join('.');
    return `${protocol}//${domain}`;
  }
  
  return `${protocol}//${hostname}`;
};
